import { render, staticRenderFns } from "./linking-data.vue?vue&type=template&id=5b99c65f&"
import script from "./linking-data.vue?vue&type=script&lang=js&"
export * from "./linking-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports